import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requirePaid = false, requireAdmin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="max-w-6xl mx-auto px-6 py-24 text-center text-[var(--ink-soft)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requirePaid && !user.is_paid && user.role !== "admin") return <Navigate to="/unlock" replace />;
  return children;
}
